export default __webpack_public_path__ + "static/media/maintenance.a325bf1c.png";